/**
 * Faithful port of DrawMapUtil.hatchingRectangle / linearHatching / perpendicularHatching.
 * Returns array of [[x1,y1],[x2,y2]] in absolute coordinates.
 */
export function buildHatchLines(x, y, width, height, step, perpendicular = false) {
    const lines = [];
    if (width <= 0 || height <= 0 || step <= 0) {
        return lines;
    }

    // Java int division
    const countStep = Math.floor((width + height) / step);
    const countStepX = Math.floor(width / step);
    const countStepY = Math.floor(height / step);

    pushLinearHatch(lines, x, y, width, height, step, countStep, countStepX, countStepY);
    if (perpendicular) {
        pushPerpendicularHatch(lines, x, y, width, height, step, countStep, countStepX, countStepY);
    }
    return lines;
}

/** DrawMapUtil.linearHatching — only if countStepY > 1 */
function pushLinearHatch(lines, x, y, width, height, step, countStep, countStepX, countStepY) {
    if (countStepY <= 1) {
        return;
    }

    let y0 = step;
    let x1 = step * (countStepY + 1) - height;
    let x0 = step;
    let y1 = step * (countStepX + 1) - width;

    for (let i = 0; i < countStep; i++) {
        let fromX;
        let fromY;
        if (i < countStepY) {
            fromX = 0;
            fromY = y0;
            y0 += step;
        } else {
            fromX = x1;
            fromY = height;
            x1 += step;
        }

        let toX;
        let toY;
        if (i < countStepX) {
            toX = x0;
            toY = 0;
            x0 += step;
        } else {
            toX = width;
            toY = y1;
            y1 += step;
        }

        lines.push([
            [x + fromX, y + fromY],
            [x + toX, y + toY],
        ]);
    }
}

/** DrawMapUtil.perpendicularHatching — only if countStep > 1 */
function pushPerpendicularHatch(lines, x, y, width, height, step, countStep, countStepX, countStepY) {
    if (countStep <= 1) {
        return;
    }

    let y0 = step;
    let x1 = width - step;
    let x0 = width - (step * (countStepY + 1) - height);
    let y1 = step * (countStepX + 1) - width;

    for (let i = 0; i < countStep; i++) {
        let fromX;
        let fromY;
        if (i < countStepY) {
            fromX = width;
            fromY = y0;
            y0 += step;
        } else {
            fromX = x0;
            fromY = height;
            x0 -= step;
        }

        let toX;
        let toY;
        if (i < countStepX) {
            toX = x1;
            toY = 0;
            x1 -= step;
        } else {
            toX = 0;
            toY = y1;
            y1 += step;
        }

        lines.push([
            [x + fromX, y + fromY],
            [x + toX, y + toY],
        ]);
    }
}
